import { Form, Input, Row, Col, Switch, InputNumber, Select, Divider } from 'antd';
import { useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebProductTypeEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [disabledSetCardId, setDisabledSetCardId] = useState<any>(false);
    const [gmCardTypeData, setGmCardTypeData] = useState<any>();

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };
    /** 后端数据defaultService */
    let defaultService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'gmCardType',
                    apiExtend: 'showList',
                }).then(res => {
                    if (res.success) {
                        setGmCardTypeData(res.data);
                    }
                })
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return };
                if (res.success === true) {
                    const isSetCardId = res.data.isSetCardId;
                    setDisabledSetCardId(!isSetCardId);
                }
            })
        }
        const fetchData = async () => {
        };
        fetchData();
    }, []);

    /**
     * 设置状态
     * @param states 
     */
    const setDisabled = (states: boolean) => {
        setDisabledSetCardId(states);
    }

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'webGiftMemberCardType',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '礼品卡类型'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={8}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={9}>
                            <Form.Item
                                label="类型名称"
                                name="typeName"
                                rules={[{ required: true, message: '卡类型名称!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="使用期限(月)"
                                name="serviceLife">
                                <InputNumber />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="类型"
                                name="gmCardTypeId"
                                rules={[{ required: true, message: '类型!' }]}>
                                <Select
                                    showSearch
                                    placeholder="类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(gmCardTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="充值"
                                name="isRecharge"
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch checked={true}
                                    checkedChildren="允许"
                                    unCheckedChildren="禁止" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="转赠"
                                name="isGiven"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Divider />

                        <Col span={5}>
                            <Form.Item
                                label="设定卡号"
                                name="isSetCardId"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否"
                                    onClick={(checked) => setDisabled(!checked)}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="卡号前缀"
                                name="cardIdPrefix"
                                rules={[{ required: !disabledSetCardId, message: '卡号前缀!' }]}>
                                <Input
                                    disabled={disabledSetCardId}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="卡号长度"
                                name="cardIdLength"
                                rules={[{ required: !disabledSetCardId, message: '卡号长度!' }]}>
                                <InputNumber
                                    disabled={disabledSetCardId}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="卡号后缀"
                                name="cardIdSuffix"
                                rules={[{ required: !disabledSetCardId, message: '卡号后缀!' }]}>
                                <Input
                                    disabled={disabledSetCardId}
                                />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebProductTypeEdit;